<template>
  <div class="playersInforRadar" ref="playersInforRadar">
    <div class="playerItem home">
      <span class="playerLogo" :class="homeLogo ? 'isLogo' : ''">
        <img v-if="homeLogo" :src="homeLogo" />
      </span>
      <span
        class="playerInfor"
        v-for="(item, index) in homePlayerInfor"
        :key="index"
      >
        <span v-text="item" :class="themeType == 'team' ? 'team' : ''"></span>
      </span>
    </div>
    <div class="themeData">
      <div
        class="echart_dom"
        ref="echartDom_home"
        :style="{ height: `${pHeight}px` }"
      ></div>
    </div>
    <div class="playerItem away">
      <span class="playerLogo" :class="awayLogo ? 'isLogo' : ''">
        <img v-if="awayLogo" :src="awayLogo" />
      </span>
      <span
        class="playerInfor"
        v-for="(item, index) in awayPlayerInfor"
        :key="index"
      >
        <span v-text="item" :class="themeType == 'team' ? 'team' : ''"></span>
      </span>
    </div>
  </div>
</template>

<script>
// 球员数据对比 主题
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'playersInforRadar',
  mixins: [canvasToImage_base64_data_mixin],
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        title: '',
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
    themeType: {
      type: String,
      default: 'player',
    },
    currThemeObj: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      echartsArr: [],
      pHeight: 0,
      homeLogo: null,
      awayLogo: null,
      homePlayerInfor: null,
      awayPlayerInfor: null,
    }
  },
  watch: {
    datas(val) {
      setTimeout(() => {
        this.initChart(this.$refs.echartDom_home, this.isAutoExportPng)
      }, 10)
    },
  },
  created() {
    let radarColor = ['rgba(224, 20, 20, 1)', 'rgba(53, 192, 213, 1)']
    if (this.currThemeObj && this.currThemeObj.cssStyle) {
      radarColor = [
        this.currThemeObj.cssStyle.combatBar1_1,
        this.currThemeObj.cssStyle.combatBar1_2,
      ]
    }
    this.radarColor = radarColor
    console.debug('playersInforRadar:', this.datas, this.currThemeObj)
  },
  mounted() {
    this.$nextTick(() => {
      this.initDomWH()
      setTimeout(() => {
        this.initChart(this.$refs.echartDom_home, this.isAutoExportPng)
      }, 10)
    })
  },
  beforeDestroy() {
    //性能优化，防止溢出
    if (this.myEChart) {
      this.myEChart.dispose() //销毁echarts实例，防止内侧泄露
    }
    this.echartsArr = []
  },
  methods: {
    initDomWH() {
      const echartsBoxDom = this.$refs.playersInforRadar
      console.debug('playersInforRadar:', echartsBoxDom.clientWidth)
      this.pWidth = echartsBoxDom.clientWidth

      this.pHeight = echartsBoxDom.clientHeight
      console.debug('this.pWidth:', this.pWidth, this.pHeight)
    },
    initChart(echartRef, isAutoExportPng) {
      const name = 'playersInforRadar'
      let result = this.echartsArr.some((val) => {
        if (val.name === name) {
          return true
        }
      })

      console.debug('result', result)

      if (!result) {
        let Echart = this.$echarts.init(echartRef)
        this.echartsArr.push({
          name: name,
          refs: echartRef,
          echarts: Echart,
        })
        setTimeout(() => {
          Echart.resize()
        }, 0)
      }
      const objectInfo = this.datas.objectInfo
      const keyArr = this.datas.statisticsModels
      const dataList = this.datas.data.dataList
      const maxList = this.datas.data.maxList
      this.homePlayerInfor = computedInforArr(objectInfo[0], this.themeType)
      this.awayPlayerInfor = computedInforArr(objectInfo[1], this.themeType)

      function computedInforArr(item, themeType) {
        const inforArr = []
        if (themeType === 'player') {
          inforArr.push(
            `号码：${
              item.playerInfos[0].shirtNumber
                ? item.playerInfos[0].shirtNumber
                : ''
            }`
          )
          inforArr.push(
            `位置：${
              item.playerInfos[0].positionName
                ? item.playerInfos[0].positionName
                : ''
            }`
          )
          inforArr.push(
            `体重：${
              item.playerInfos[0].weight
                ? item.playerInfos[0].weight + 'kg'
                : ''
            }`
          )
          inforArr.push(
            `姓名：${
              item.playerInfos[0].playerName
                ? item.playerInfos[0].playerName
                : ''
            }`
          )
          inforArr.push(
            `年龄：${item.playerInfos[0].age ? item.playerInfos[0].age : ''}`
          )
          inforArr.push(
            `身高：${
              item.playerInfos[0].height
                ? item.playerInfos[0].height + 'cm'
                : ''
            }`
          )
        } else {
          inforArr.push(`${item.teamName ? item.teamName : ''}`)
        }
        return inforArr
      }

      if (this.themeType === 'player') {
        this.homeLogo =
          objectInfo[0] && objectInfo[0].playerInfos[0]
            ? objectInfo[0].playerInfos[0].profilePicture
            : ''
        this.awayLogo =
          objectInfo[1] && objectInfo[1].playerInfos[0]
            ? objectInfo[1].playerInfos[0].profilePicture
            : ''
      } else {
        this.homeLogo =
          objectInfo[0] && objectInfo[0].teamLogo ? objectInfo[0].teamLogo : ''
        this.awayLogo =
          objectInfo[1] && objectInfo[1].teamLogo ? objectInfo[1].teamLogo : ''
      }
      const homePlayerName =
        objectInfo[0] && objectInfo[0].playerInfos[0]
          ? objectInfo[0].playerInfos[0].playerName
          : ''
      const awayPlayerName =
        objectInfo[1] && objectInfo[1].playerInfos[0]
          ? objectInfo[1].playerInfos[0].playerName
          : ''
      const homeName =
        objectInfo[0] && objectInfo[0].teamName ? objectInfo[0].teamName : ''
      const awayName =
        objectInfo[1] && objectInfo[1].teamName ? objectInfo[1].teamName : ''

      let radarNameArr = []
      if (this.themeType === 'player') {
        radarNameArr.push(homePlayerName)
        radarNameArr.push(awayPlayerName)
      } else {
        radarNameArr.push(homeName)
        radarNameArr.push(awayName)
      }
      const indicator = keyArr.map((model) => {
        return {
          name: model.name,
          max: maxList[model.statisticalEn],
        }
      })
      const seriesData = dataList.map((item, index) => {
        const value = keyArr.map((key) => {
          console.debug(key, item[key['statisticalEn']])
          return item[key['statisticalEn']] ? item[key['statisticalEn']] : 0
        })
        return {
          value,
          name: radarNameArr[index],
        }
      })

      console.debug('radarNameArr:', radarNameArr)
      let options = {
        title: {
          show: false,
          text: 'Basic Radar Chart',
        },
        color: this.radarColor,
        legend: {
          show: true,
          data: radarNameArr,
          top: '4%',
        },
        tooltip: {
          show: true,
        },
        radar: {
          // shape: 'circle',
          center: ['50%', '50%'],
          radius: this.pWidth < 600 ? '50%' : '55%',
          indicator,
          axisName: {
            formatter: function(value) {
              const result = [];
              for (let i = 0; i < value.length; i += 5) {
                result.push(value.slice(i, i + 5));
              }
              return result.join('\n');
            }
          }
          // indicator: [
          //   { name: 'Sales', max: 6500 },
          //   { name: 'Administration', max: 16000 },
          //   { name: 'Information Technology', max: 30000 },
          //   { name: 'Customer Support', max: 38000 },
          //   { name: 'Development', max: 52000 },
          //   { name: 'Marketing', max: 25000 },
          // ],
        },
        series: [
          {
            name: `${radarNameArr[0]} vs ${radarNameArr[1]}`,
            type: 'radar',
            // itemStyle: {
            //   color: 'blue',  //控制雷达塔覆盖区域颜色
            // },
            areaStyle: {
              opacity: 0.1, //控制雷达塔覆盖区域颜色透明度
            },
            // label: {
            //   formatter: function(val) {

            //   }
            // },
            data: seriesData,

            // data: [
            //   {
            //     value: [4200, 3000, 20000, 35000, 50000, 18000],
            //     name: homeName,
            //   },
            //   {
            //     value: [5000, 14000, 28000, 26000, 42000, 21000],
            //     name: awayName,
            //   },
            // ],
          },
        ],
      }
      this.echartsArr.forEach((val, index) => {
        if (val.name === name) {
          console.debug('val.name:', val.name, 'name', name)
          val.echarts.setOption(options)
        }
      })
      //   console.debug('emitEventName:', isAutoExportPng)
      //   if (isAutoExportPng) {
      //     setTimeout(() => {
      //       this.upLoad(echartRef, true, 'uploadData')
      //     }, 500)
      //   }
    },
  },
}
</script>

<style lang="scss" scoped>
.playersInforRadar {
  position: relative;
  width: 100%;
  height: 22vw;
  padding: 0 3%;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  .playerItem {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 6.94vw;
    .playerLogo {
      margin-bottom: 1.388vw;
      width: 4.166vw;
      height: 4.166vw;
      border-radius: 50%;
      overflow: hidden;
      background-size: 100% auto;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center top;
      background-image: var(--mixtmt_default_playerLogo);
      &.isLogo {
        background-image: none;
      }
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 50%;
      }
    }
    .playerInfor {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      & .team {
        text-align: center;
      }
      span {
        width: 100%;
        font-size: 0.972vw;
        line-height: 1.388vw;
        color: rgba(0, 0, 0, 0.85);
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    /* &.home {
      .playerInfor {
        
      }
    }
    &.away {
      .playerInfor {
        align-items: flex-start;
      }
    } */
  }
  .themeData {
    width: calc(100% - 13.88vw);
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    .echart_dom {
      width: 85%;
    }
  }
}
.mixtmt_ipad .playersInforRadar {
  padding: 0 2%;
  .themeData {
    .echart_dom {
      width: 85%;
    }
  }
}
</style>
